export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-send-plane-line text-2xl text-accent-600"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-md mx-auto">
            如果您有韩漫网站推荐、投稿建议或合作意向，欢迎通过以下方式联系我们
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-line"></i>
              推荐韩漫网站
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-md hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-question-answer-line"></i>
              意见反馈
            </a>
          </div>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-400">
            <span className="inline-flex items-center gap-1">
              <i className="ri-time-line"></i> 工作日 9:00-18:00
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-refresh-line"></i> 通常在24小时内回复
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}